import { useContext } from 'react';
import styled from '@emotion/styled';
import { LangContext } from '../context/LangContext'; 
import { DeviceContext } from '../context/DeviceContext'; 
import theme from '../theme';
import { Link, useLocation, useNavigate } from 'react-router-dom';

export default function Footer({sectionRefs, setActiveIndex}) {

    const navigate = useNavigate();
    const location = useLocation();
    const { selectLanguage } = useContext(LangContext);
    const { isMobile } = useContext(DeviceContext);

    const Footer = styled.div`                
        margin: auto;
        background-color: black;
        font-family: "Black Han Sans";     
        padding: 48px 7%;
        font-size:22px;

        ${theme.breakpoints.xl_1920} {      
            font-size:20px;
        }

        ${theme.breakpoints.xl} {
            padding:24px 16px;
        }
    `;

    const FooterTop = styled.div`        
        display: flex;
        justify-content: space-between;
        align-items: center;
    `;

    const FooterTopImg = styled.div`        
        background-color:black;

        ${theme.breakpoints.xl} {
            text-align:center;
            margin-bottom:16px;
        }
    `;

    const FooterTopRight = styled.div`        
        display: flex;
        gap:14px;        
        justify-content: center;
        align-items: center;

        font-size:20px;
        color:#757575;

        div img {
            height: 40px;
        }

        a{
            text-decoration:none;
            color:#757575;
        }
        
        ${theme.breakpoints.xl} {
            gap:16px;
            margin-bottom:16px;
            div img {
                height:24px;
            }
        }

    `;

    const FooterMiddle = styled.div`
        display:flex;
        align-items:center;
        justify-content:space-between;
        margin-top:20px;
        color:#757575;
    `;

    const FooterHr = styled.hr`
        margin:24px 0;
        border:0.5px solid #201F1F;
    `;

    const FooterBottom = styled.div`
        display: flex;
        align-items: center;
        justify-content: space-between;        
        color:#757575;
    `;

    const FooterTopText = styled.div`
        font-size:20px;
        //font-family: Roboto;
        font-family: 'Roboto Sans', sans-serif;
        font-weight: 500;

        ${theme.breakpoints.xl} {
            font-size:10px;        
            color:#757575;
            text-align:center;
        }
    `;

    const FooterBottomRight = styled.div`
        display: flex;
        align-items: center;
        justify-content: center;
        //font-family: Roboto;
        font-family: 'Roboto Sans', sans-serif;
        //font-weight:900;
        //font-style:italic;
        
        font-weight:500;        
        gap:14px; 

        a{
            text-decoration:none;
            color:#757575;
        }

        span{            
            color:#757575;
        }
        

        ${theme.breakpoints.xl_1920} {
            font-weight:500;        
        }

        ${theme.breakpoints.xl} {
            font-size:12px;
            font-weight:600;
            color:#757575;
        }

    `;

    const FooterStick = styled.div`
        width:.5px;
        height:16px;
        border-left:1px solid #201F1F;
    `;


    const handleMenuClick = (index) => {
        if(selectLanguage === '한국어'){
            window.scrollTo({
                top: sectionRefs[index].current.offsetTop - 50,
                behavior: 'smooth'
            });
            setActiveIndex(index);
        }else{
            if(isMobile){
                setActiveIndex(index);
                navigate('/')
            }else{            
                setActiveIndex(index);            
    
                if(location.pathname === "/"){
                    window.scrollTo({
                        top: sectionRefs[index].current.offsetTop - 50,
                        behavior: 'smooth'
                    });            
                }else{
                    navigate('/')
                }            
            }
        }
      };


  return (
    <>
        {
            isMobile ? 
            <>
                <Footer>
                    <FooterBottomRight>
                        <a target="_blank" href="/docs/Terms_of_Service_MCN.pdf"><span>Terms of Service</span></a>                    
                        <FooterStick></FooterStick>
                        <a target="_blank" href="/docs/Privacy_Policy_MCN.pdf"><span>Privacy Policy</span></a>
                        <FooterStick></FooterStick>
                        <a href="mailto:contact@meta-creator.network">Contact</a>
                    </FooterBottomRight>
                    <FooterHr/>

                    <FooterTopRight>
                        <div>
                            <Link to={`${selectLanguage === '한국어' 
                                ? 'https://youtu.be/4Q1ttZBLE6E'
                                : 'https://youtu.be/k6Umdj3p2pY'}`
                                } target="_blank">
                                <img src="/images/icon/trailer.png" alt="icon"/>
                            </Link>
                        </div>
                        <div>
                            <Link to="https://discord.gg/metatoyworld" target="_blank">                            
                                <img src="/images/icon/discord.png" alt="icon"/>
                            </Link>
                        </div>
                        <div>
                            {selectLanguage === '한국어' 
                            ?
                                <Link to="https://game.naver.com/lounge/Meta_Toy_DragonZ_SAGA/home" target="_blank">
                                    <img src="/images/icon/zzz.png" alt="icon"/>
                                </Link>
                            :
                                <Link to="https://twitter.com/MetaToyDragonZ" target="_blank">
                                    <img src="/images/icon/x.png" alt="icon"/>
                                </Link>
                            }                            
                        </div>
                        <div>
                            <Link to={selectLanguage === '한국어' 
                            ? 'https://sandboxnetwork.zendesk.com/hc/ko/requests/new?ticket_form_id=22568004516633'
                            : 'https://sandboxnetwork.zendesk.com/hc/en-us/requests/new?ticket_form_id=22568004516633'}
                            target="_blank">
                                <img src="/images/icon/help.png" alt="icon"/>
                            </Link>
                        </div>
                    </FooterTopRight>

                    <FooterTopImg><img src="/images/logo/mcn.png" alt="" style={{height:'40px'}}/></FooterTopImg>
                    
                    <FooterTopText>
                        ⓒ Meta Creator Network, Inc. All rights reserved.
                    </FooterTopText>
                </Footer>
            </>
        : <Footer>
            <FooterTop>
                <FooterTopImg><img src="/images/logo/mcn.png" alt="" style={{height:'60px'}}/></FooterTopImg>
                <FooterTopRight>
                    <Link to="/" onClick={() => {handleMenuClick(2)}}>
                        {selectLanguage === '한국어' ? '사전예약 보상' : 'REWARD'}
                    </Link>

                    {selectLanguage === '한국어' ?
                        <Link to="/" onClick={() => {handleMenuClick(3)}}>
                            게임 소개  
                        </Link>
                         :
                         <>
                         <Link to="/" onClick={() => {handleMenuClick(3)}}>
                            FEATURE
                        </Link>                        
                        {/* <Link to="/metodium"                         
                            style={{color: '#757575',textDecoration: 'none',transition: 'color 0.4s ease'}}
                            //onMouseEnter={e => (e.target.style.color = 'white')}
                            //onMouseLeave={e => (e.target.style.color = '#FF6F1E')}
                        >
                            METODIUM
                        </Link> */}
                        </>
                    }
                        
                    <Link to="https://play.carv.io/events/4dd51c33-5ab5-5586-ad5c-1e85c0d62380/detail" target='_blank'>
                        <div style={{color:'#FF6F1E'}}>
                                {selectLanguage === '한국어' ? '사전예약' : 'PRE-REGISTER'}
                        </div>
                    </Link>
                </FooterTopRight>
            </FooterTop>

            <FooterMiddle>
                <FooterTopText>
                    All trademarks referenced herein are the properties of their respective owners.  
                </FooterTopText>
                <FooterTopRight>
                    <div>
                        <Link to={`${selectLanguage === '한국어' 
                            ? 'https://youtu.be/4Q1ttZBLE6E'
                            : 'https://youtu.be/k6Umdj3p2pY'}`
                            } target="_blank">
                            <img src="/images/icon/trailer.png" alt="icon" style={{height:'40px'}}/>
                        </Link>
                    </div>
                    <div>
                        <Link to="https://discord.gg/metatoyworld" target="_blank">                            
                            <img src="/images/icon/discord.png" alt="icon" style={{height:'40px'}}/>
                        </Link>
                    </div>
                    <div>
                        {selectLanguage === '한국어' 
                        ?
                            <Link to="https://game.naver.com/lounge/Meta_Toy_DragonZ_SAGA/home" target="_blank">
                                <img src="/images/icon/zzz.png" alt="icon" style={{height:'40px'}}/>
                            </Link>
                        :
                            <Link to="https://twitter.com/MetaToyDragonZ" target="_blank">
                                <img src="/images/icon/x.png" alt="icon" style={{height:'40px'}}/>
                            </Link>
                        }                        
                    </div>
                    <div>
                        <Link to={selectLanguage === '한국어' 
                        ? 'https://sandboxnetwork.zendesk.com/hc/ko/requests/new?ticket_form_id=22568004516633'
                        : 'https://sandboxnetwork.zendesk.com/hc/en-us/requests/new?ticket_form_id=22568004516633'}
                        target="_blank">
                            <img src="/images/icon/help.png" alt="icon" style={{height:'40px'}}/>
                        </Link>
                    </div>
                </FooterTopRight>
            </FooterMiddle>
            <FooterHr/>
            <FooterBottom>
                <FooterTopText>
                ⓒ Meta Creator Network, Inc. All rights reserved.
                </FooterTopText>
                <FooterBottomRight>
                    <a target="_blank" href="/docs/Terms_of_Service_MCN.pdf"><span>Terms of Service</span></a>                    
                    <FooterStick></FooterStick>
                    <a target="_blank" href="/docs/Privacy_Policy_MCN.pdf"><span>Privacy Policy</span></a>
                    <FooterStick></FooterStick>
                    <a href="mailto:contact@meta-creator.network">Contact</a>
                </FooterBottomRight>
            </FooterBottom>
        </Footer>
        }
     </>    
  )
}
